import { Directive, ElementRef, OnInit, OnDestroy } from "@angular/core";
import { VideoSyncService } from "./video-sync-service";

@Directive({
  selector: "[syncVideo]",
})
export class SyncVideoDirective implements OnInit, OnDestroy {
  constructor(
    private el: ElementRef<HTMLVideoElement>,
    private videoSyncService: VideoSyncService
  ) {}

  ngOnInit() {
    this.videoSyncService.registerPlayer(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.videoSyncService.unregisterPlayer(this.el.nativeElement);
  }
}
